module.exports = __webpack_public_path__ + "img/front_5.44160067.svg";